import React, { Component } from 'react';
import { ErrorOutlineRounded } from '@material-ui/icons';

/**
 * @description 查無結果
 * @param {string} title 描述文字
 */
class NoResults extends Component {
    render() {
        return (
            <div className={"errorGroup"}>
                <ErrorOutlineRounded />
                <span>{this.props.title === undefined ? "查無結果" : this.props.title}</span>
            </div>
        );
    }
}

export {
    NoResults
};